import { useEffect, useState } from "react";
import Button from "../common/Button";
import BaseModal from "../modals/BaseModal";

export default function AssignCampaignModal({
  open,
  member,
  campaigns,
  busy,
  onClose,
  onSubmit,
}) {
  const [selectedCampaign, setSelectedCampaign] = useState("");

  useEffect(() => {
    if (!open) {
      return;
    }

    setSelectedCampaign(member?.assigned_campaign || campaigns[0] || "");
  }, [campaigns, member, open]);

  if (!member) {
    return null;
  }

  return (
    <BaseModal
      open={open}
      onClose={busy ? () => {} : onClose}
      title="Assign Campaign"
      meta="Select a live campaign and update the selected team member."
      modalId="assign-campaign-modal"
      className="team-modal"
    >
      <form
        className="outbound-form"
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit({ campaignName: selectedCampaign });
        }}
      >
        <div className="modal-summary-block">
          <div className="modal-summary-label">Selected Team Member</div>
          <div className="modal-summary-text">{member.name}</div>
        </div>

        <label className="outbound-field">
          <span className="outbound-label">Campaign</span>
          <select
            className="team-modal-select"
            value={selectedCampaign}
            onChange={(event) => setSelectedCampaign(event.target.value)}
            disabled={busy}
          >
            {campaigns.map((campaign) => (
              <option key={campaign} value={campaign}>
                {campaign}
              </option>
            ))}
          </select>
        </label>

        <div className="modal-actions">
          <Button onClick={onClose} disabled={busy}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="gold"
            disabled={busy || !selectedCampaign}
          >
            {busy ? "Assigning..." : "Assign Campaign"}
          </Button>
        </div>
      </form>
    </BaseModal>
  );
}
